import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import SelfServiceMobile from "./SelfServiceMobile";
import SelfServiceDesktop from "./SelfServiceDesktop";

function SelfService({ config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <SelfServiceMobile config={config} />
  ) : (
    <SelfServiceDesktop config={config} />
  );
}

SelfService.defaultProps = {
  app: null,
  config: {},
};

SelfService.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SelfService;
